import React from "react";
import { Swords, Loader2, FileSpreadsheet, FileText } from "lucide-react";
import { TID } from "@/lib/testIds";

// Executive brand portrait — metallic shield + Blue/Red duotone city glow, matches the cinematic theme
const ROLE_HERO_IMG = "https://customer-assets-v7afamib.emergentagent.net/job_c412f59b-2024-4cb6-bf11-5a742907db03/artifacts/mxr2musr_ChatGPT%20Image%20Jul%2029%2C%202026%2C%2004_05_50%20PM.png";

export function RoleEngineeringHero({ exporting, onExport, disabled }) {
    return (
        <div data-testid="role-hero-banner" className="panel-elevated relative overflow-hidden p-6">
            <img
                src={ROLE_HERO_IMG}
                alt=""
                className="theme-photo absolute inset-0 w-full h-full object-cover opacity-45 mix-blend-screen pointer-events-none"
                style={{ objectPosition: "70% 15%" }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#05050A] via-[#05050A]/70 to-transparent pointer-events-none" />
            <div className="absolute -right-10 -top-10 w-56 h-56 rounded-full bg-rose-500/10 blur-3xl pointer-events-none" />
            <div className="flex items-center justify-between gap-4 relative flex-wrap">
                <div className="flex items-center gap-4">
                    <div className="chrome-bevel w-12 h-12 rounded-sm bg-gradient-to-br from-cyan-300 to-cyan-600 flex items-center justify-center shadow-[0_0_20px_rgb(var(--accent-1-rgb) / 0.45)]">
                        <Swords size={22} className="text-slate-950" strokeWidth={2.5} />
                    </div>
                    <div>
                        <h1 className="font-display text-2xl text-white tracking-wide">
                            SENTINEL <span className="text-cyan-400">FORGE</span>
                        </h1>
                        <p className="text-sm text-slate-400 mt-0.5">
                            Mass PFCG role generation · Field-verified SoD analysis · GenAI consolidation
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    <button
                        data-testid={TID.roleExportBtn("xlsx")}
                        onClick={() => onExport("xlsx")}
                        disabled={exporting === "xlsx" || disabled}
                        className="inline-flex items-center gap-1.5 px-3 py-2 panel text-xs font-mono text-slate-300 hover:text-cyan-300 hover:border-cyan-500/30 transition-colors disabled:opacity-40"
                    >
                        {exporting === "xlsx" ? <Loader2 size={14} className="animate-spin" /> : <FileSpreadsheet size={14} />}
                        Excel
                    </button>
                    <button
                        data-testid={TID.roleExportBtn("pdf")}
                        onClick={() => onExport("pdf")}
                        disabled={exporting === "pdf" || disabled}
                        className="inline-flex items-center gap-1.5 px-3 py-2 panel text-xs font-mono text-slate-300 hover:text-cyan-300 hover:border-cyan-500/30 transition-colors disabled:opacity-40"
                    >
                        {exporting === "pdf" ? <Loader2 size={14} className="animate-spin" /> : <FileText size={14} />}
                        PDF
                    </button>
                </div>
            </div>
        </div>
    );
}
